<form class="verification w-100" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div>
    <ng-container *ngIf="showHint">
      <h4 class="mb-3 f-size-20-md-sm">{{ 'EMAIL_VERIFICATION' | translate }}</h4>

      <h3 class="mb-5 d-flex flex-column align-items-start">
        <label>
          {{ 'ENTER_OTP_MESSAGE' | translate }} <span>{{ email }}, </span>
          <ng-container *ngIf="mobileNumber">
            {{ 'AND_MOBILE_NUMBER' | translate }} <span>{{ mobileNumber }}, </span>
          </ng-container>
          {{ 'WITHIN_NEXT_7_MINUTES' | translate }}
        </label>
        <button (click)="changeStep.emit()" mat-button type="button" [disableRipple]="true" class="no-access">
          {{ 'I_HAVE_NO_ACCESS_EMAIL' | translate }}
        </button>
      </h3>
    </ng-container>

    <div class="form-group">
      <label for="code">{{ 'ENTER_CODE' | translate }}</label>
      <div class="align">
        <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
      </div>
    </div>

    <div class="form-group mt-4 mb-2">
      <metutors-submit-button [form]="form" [isSubmitting]="loading" [extraClasses]="'w-100 rounded-btn'">
        {{ submitLabel | translate }}
      </metutors-submit-button>
    </div>

    <div class="form-group mt-4 mb-2 resend-code">
      <span>{{ 'DIDNT_RECEIVE_VERIFICATION_CODE' | translate }}</span>
      <button mat-button (click)="resendEmailConfirm()"
              [disabled]="resendLoading || loading" [disableRipple]="true">
        {{ 'RESEND_OTP_AGAIN' | translate }}
        <mat-icon class="spinner" *ngIf="resendLoading">autorenew</mat-icon>
      </button>
    </div>
  </div>
</form>
